import React, {useEffect} from 'react';
import {embedDashboard} from '@superset-ui/embedded-sdk';
import {useParams} from 'react-router-dom';

const SupersetDashboard = () => {

  const { dashboardID } = useParams();
  const supersetUrl = 'https://superset.datenraum-dev.freiburg.de';
  const backendUrl = 'https://superset-embedding-backend.datenraum-dev.freiburg.de';
  const talamedUrl = 'https://tala-med.datenraum-dev.freiburg.de';
  const uid = '80c12cf2-ca18-413d-97c7-ac5ae0bb5975';

  const currentOrigin = window.location.origin;
  const isTalamed = currentOrigin === talamedUrl;
  const id = isTalamed ? uid : dashboardID;

  useEffect(() => {
    async function fetchToken() {
      const token = await getTokenLocal();
      if (token) {
        embedDashboard({
          id: id,
          supersetDomain: supersetUrl,
          mountPoint: document.getElementById("dashboard"),
          fetchGuestToken: () => token,
        });
        document.getElementById("dashboard").children[0].width="100%";
        document.getElementById("dashboard").children[0].height="100%";
      }
    }
    fetchToken();
  }, [id]);

  async function getTokenLocal() {
    try {
      const requestUrl = `${backendUrl}:443/get_guest_token?dashboard=${id}`;
      const response = await fetch(requestUrl);
      const data = await response.json();
      return data.message;
    } catch (error) {
      return null;
    }
  }
  return (
    <div id='dashboard' style={{width: '100%', height: '100vh'}}/>
  );
};
export default SupersetDashboard;
